import { registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./contentTile.html";
import { BaseMolecular, getObjectAttr } from 'wds/common';
import { TileVariants } from 'wds/tile';
class ContentTile extends BaseMolecular {
  constructor(...args) {
    super(...args);
    this.variant = TileVariants.Transparent;
    this.positionIndex = void 0;
    this.altTextMessage = () => `image for ${this.title}`;
  }
  set props(value) {
    const props = getObjectAttr(value);
    if (props) {
      this.id = props.id;
      this.title = props.title;
      this.description = props.description;
      this.callToAction = props.callToAction;
      if (props.image) {
        if (typeof props.image === 'string') {
          this.image = {
            url: props.image,
            altText: props.alt_text || this.altTextMessage()
          };
        } else {
          this.image = props.image;
        }
      }
      this.listingType = props.type;
    }
  }
  get props() {
    return {
      title: this.title,
      description: this.description,
      callToAction: this.callToAction,
      image: this.image,
      positionIndex: this.positionIndex,
      listingType: this.listingType
    };
  }
  handleClick(event) {
    const clickEvent = new CustomEvent('navigate', {
      detail: {
        action: this.callToAction.url,
        event: event
      },
      composed: true,
      bubbles: true,
      cancelable: true
    });
    // If navigate is catched prevents the anchor to continue
    if (!this.dispatchEvent(clickEvent)) {
      event.preventDefault();
    }
  }
  handleAnalytics(event) {
    event.detail.content = this.props;
  }
  clickElement(target) {
    const anchors = this.template.querySelectorAll('.link');
    if (anchors.length > 0) {
      const anchor = anchors[0];
      if (anchor.target !== target) {
        const currentTarget = anchor.target;
        anchor.target = target;
        anchor.click();
        anchor.target = currentTarget;
      } else {
        anchor.click();
      }
    }
  }
  isNewWindow(clickEvent) {
    const isMacPlatform = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    return isMacPlatform && clickEvent.metaKey || !isMacPlatform && clickEvent.ctrlKey;
  }
  handleKeyPress(event) {
    if (event.code === 'Enter') {
      const target = this.isNewWindow(event) ? '_blank' : '_self';
      this.clickElement(target);
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ContentTile, {
  publicProps: {
    variant: {
      config: 0
    },
    positionIndex: {
      config: 0
    },
    altTextMessage: {
      config: 0
    },
    props: {
      config: 3
    }
  }
});
const __lwc_component_class_internal = _registerComponent(ContentTile, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;